@if (loading()) {
    <div class="loading-animals-in-range">
        <p>Loading animals in range...</p>
    </div>
} @else if (animalIdsInRange().length > 0) {
    <div class="d-flex flex-column gap-2">
        @for (animalId of animalIdsInRange(); track animalId) {
            <app-animal-button [id]="animalId"
                               [selectableForAlteration]="false"
                               [selectableForDeletion]="false"
                               [standalone]="true"/>
        }
    </div>
} @else {
    <div class="no-animals-in-range">
        <p>No animals in range.</p>
    </div>
}
